// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7065":"37a54880","8539":"35114871"}[chunkId] + ".chunk.css";
};